import SourceFlowText from "@sourceflow-uk/sourceflowtext";
import SourceFlowImage from "@sourceflow-uk/sourceflowimage";
import { Container, Row, Col } from "reactstrap";
import styles from "./styles.module.scss";
import Link from "next/link";
import Locations from "/public/site-assets/svg/our-branches-new.svg";
import { motion, useScroll } from "framer-motion";

export default function OurBranches({
  global,
  pathPrefix,
  customClass = "",
  buttonTitle,
  buttonLink,
  heading,
  content,
  showImageonMap = false,
}) {
  return (
    <>
      <section className={`${styles.root} ${customClass}`}>
        <Container>
          <Row className="m-0">
            <Col lg={6} className="left p-0 overflow-hidden mb-2 mb-lg-0">
              <div className="content-wrapper p-lg-5 p-4">
                <h2 className="mb-4">
                  <SourceFlowText
                    global={global}
                    path={`${pathPrefix}.heading`}
                  >
                    {heading}
                  </SourceFlowText>
                </h2>
                <p className="fs-6 subtitle position-relative d-inline-block pe-5 text-white">
                  <SourceFlowText
                    global={global}
                    path={`${pathPrefix}.content`}
                  >
                    {content}
                  </SourceFlowText>
                </p>
                <div className="mt-4">
                  <Link href={buttonLink}>
                    <a className="primaryBtn text-decoration-none">
                      <SourceFlowText
                        global={global}
                        path={`${pathPrefix}.buttonTitle`}
                      >
                        {buttonTitle}
                      </SourceFlowText>
                    </a>
                  </Link>
                </div>
              </div>
            </Col>
            <Col lg={6} className="right p-0 overflow-hidden position-relative">
              <div className="content-wrapper p-lg-5 p-0 h-100 ">
                <div className="map-mainWrapper">
                  <span className="position-absolute locations-img">
                    <Locations />
                  </span>
                  <motion.span
                    initial={{ opacity: 0.05, y: 40 }}
                    animate="visible"
                    whileInView={{
                      opacity: 1,
                      y: 0,
                      transition: { duration: 0.5, delay: 0.5 },
                    }}
                    viewport={{ once: true }}
                    className="position-absolute location-1 shadow rounded-3 overflow-hidden h-100"
                  >
                    {showImageonMap ? (
                      <SourceFlowImage
                        src="/site-assets/images/location-1.jpg"
                        size="500x500"
                        alt="Location 1"
                        className="card-img"
                        width="100%"
                        height="100%"
                      />
                    ) : (
                      ""
                    )}
                  </motion.span>
                  <motion.span
                    initial={{ opacity: 0.05, y: 40 }}
                    animate="visible"
                    whileInView={{
                      opacity: 1,
                      y: 0,
                      transition: { duration: 0.5, delay: 0.5 },
                    }}
                    viewport={{ once: true }}
                    className="position-absolute location-2 shadow rounded-3 overflow-hidden h-100"
                  >
                    {showImageonMap ? (
                      <SourceFlowImage
                        src="/site-assets/images/location-2.jpg"
                        size="500x500"
                        alt="Location 2"
                        className="card-img rounded-3"
                        width="100%"
                        height="100%"
                      />
                    ) : (
                      ""
                    )}
                  </motion.span>
                  <motion.span
                    initial={{ opacity: 0.05, y: 40 }}
                    animate="visible"
                    whileInView={{
                      opacity: 1,
                      y: 0,
                      transition: { duration: 0.5, delay: 0.5 },
                    }}
                    viewport={{ once: true }}
                    className="position-absolute location-3 shadow rounded-3 overflow-hidden h-100"
                  >
                    {showImageonMap ? (
                      <SourceFlowImage
                        src="/site-assets/images/location-3.jpg"
                        size="500x500"
                        alt="Location 3"
                        className="card-img"
                        width="100%"
                        height="100%"
                      />
                    ) : (
                      ""
                    )}
                  </motion.span>
                  <motion.span
                    initial={{ opacity: 0.05, y: 40 }}
                    animate="visible"
                    whileInView={{
                      opacity: 1,
                      y: 0,
                      transition: { duration: 0.5, delay: 0.5 },
                    }}
                    viewport={{ once: true }}
                    className="position-absolute location-4 shadow rounded-3 overflow-hidden h-100"
                  >
                    {showImageonMap ? (
                      <SourceFlowImage
                        src="/site-assets/images/location-4.jpg"
                        size="500x500"
                        alt="Location 4"
                        className="card-img"
                        width="100%"
                        height="100%"
                      />
                    ) : (
                      ""
                    )}
                  </motion.span>
                  <motion.span
                    initial={{ opacity: 0.05, y: 40 }}
                    animate="visible"
                    whileInView={{
                      opacity: 1,
                      y: 0,
                      transition: { duration: 0.5, delay: 0.5 },
                    }}
                    viewport={{ once: true }}
                    className="position-absolute location-5 shadow rounded-3 overflow-hidden h-100"
                  >
                    {showImageonMap ? (
                      <SourceFlowImage
                        src="/site-assets/images/location-5.jpg"
                        size="500x500"
                        alt="Location 5"
                        className="card-img rounded-3"
                        width="100%"
                        height="100%"
                      />
                    ) : (
                      ""
                    )}
                  </motion.span>
                </div>
              </div>
            </Col>
          </Row>

          {/* <div className="content-wrapper rounded-3 overflow-hidden p-lg-5 p-4">
                        <Row>
                            <Col lg={6} className="pe-md-5 mb-5 pb-5 pb-lg-0 mb-lg-0 left position-relative">
                                <h2 className="mb-4">
                                    <SourceFlowText global={global} path={`${pathPrefix}.heading`}>{heading}</SourceFlowText>
                                </h2>
                                <p className="fs-6 subtitle position-relative d-inline-block pe-5 text-white">
                                    <SourceFlowText global={global} path={`${pathPrefix}.content`}>{content}</SourceFlowText>
                                </p>
                                <div className="mt-4">
                                    <Link href={buttonLink}>
                                        <a className="primaryBtn text-decoration-none">
                                            <SourceFlowText global={global} path={`${pathPrefix}.buttonTitle`}>
                                                {buttonTitle}
                                            </SourceFlowText>
                                        </a>
                                    </Link>
                                </div>
                            </Col>
                            <Col lg={6} className="ps-md-5 position-relative right all-locations-point">
                                <span className="position-absolute locations-img">
                                    <Locations />
                                </span>
                                <motion.span
                                    initial={{ opacity: 0.05, y: 40 }}
                                    animate="visible"
                                    whileInView={{ opacity: 1, y: 0, transition: { duration: 0.5, delay: 0.5 } }}
                                    viewport={{ once: true }}
                                    className="position-absolute location-1 shadow rounded-3 overflow-hidden h-100"
                                >
                                    <SourceFlowImage
                                        src="/site-assets/images/location-1.jpg"
                                        size="500x500"
                                        alt="Location 1"
                                        className="card-img"
                                        width="100%"
                                        height="100%"
                                    />
                                </motion.span>
                                <motion.span
                                    initial={{ opacity: 0.05, y: 40 }}
                                    animate="visible"
                                    whileInView={{ opacity: 1, y: 0, transition: { duration: 0.5, delay: 0.5 } }}
                                    viewport={{ once: true }}
                                    className="position-absolute location-2 shadow rounded-3 overflow-hidden h-100"
                                >
                                    <SourceFlowImage
                                        src="/site-assets/images/location-2.jpg"
                                        size="500x500"
                                        alt="Location 2"
                                        className="card-img rounded-3"
                                        width="100%"
                                        height="100%"
                                    />
                                </motion.span>
                                <motion.span
                                    initial={{ opacity: 0.05, y: 40 }}
                                    animate="visible"
                                    whileInView={{ opacity: 1, y: 0, transition: { duration: 0.5, delay: 0.5 } }}
                                    viewport={{ once: true }}
                                    className="position-absolute location-3 shadow rounded-3 overflow-hidden h-100"
                                >
                                    <SourceFlowImage
                                        src="/site-assets/images/location-3.jpg"
                                        size="500x500"
                                        alt="Location 3"
                                        className="card-img"
                                        width="100%"
                                        height="100%"
                                    />
                                </motion.span>
                                <motion.span
                                    initial={{ opacity: 0.05, y: 40 }}
                                    animate="visible"
                                    whileInView={{ opacity: 1, y: 0, transition: { duration: 0.5, delay: 0.5 } }}
                                    viewport={{ once: true }}
                                    className="position-absolute location-4 shadow rounded-3 overflow-hidden h-100"
                                >
                                    <SourceFlowImage
                                        src="/site-assets/images/location-4.jpg"
                                        size="500x500"
                                        alt="Location 4"
                                        className="card-img"
                                        width="100%"
                                        height="100%"
                                    />
                                </motion.span>
                                <motion.span
                                    initial={{ opacity: 0.05, y: 40 }}
                                    animate="visible"
                                    whileInView={{ opacity: 1, y: 0, transition: { duration: 0.5, delay: 0.5 } }}
                                    viewport={{ once: true }}
                                    className="position-absolute location-5 shadow rounded-3 overflow-hidden h-100"
                                >
                                    <SourceFlowImage
                                        src="/site-assets/images/location-5.jpg"
                                        size="500x500"
                                        alt="Location 5"
                                        className="card-img rounded-3"
                                        width="100%"
                                        height="100%"
                                    />
                                </motion.span>
                            </Col>
                        </Row>
                    </div> */}
        </Container>
      </section>
    </>
  );
}
